import { render, staticRenderFns } from "./GroupsOffers.vue?vue&type=template&id=2094fe58&scoped=true&"
import script from "./GroupsOffers.vue?vue&type=script&lang=ts&"
export * from "./GroupsOffers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2094fe58",
  null
  
)

export default component.exports